export enum ReasonType {
  DoNotCalculate = 'DoNotCalculate',
  FilteredOff = 'FilteredOff',
  ReplacedWithX = 'ReplacedWithX',
  ReplacedWithY = 'ReplacedWithY',
  ReplacedWithColumn = 'ReplacedWithColumn',
}
